'use strict';

var isString = require('lodash/isString');
var isObject = require('lodash/isObject');

/**
 * Verify type of key and return the set key property
 * If shouldReturnUndefined === true will return undefined only if typeof key
 * is a string.
 * Use case: impressions tracker need matching key or bucketing key.
 */
function KeyFactory(keyProperty) {
  var shouldReturnUndefined = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  return function getKeyProperty(key) {
    if (isString(key)) {
      return shouldReturnUndefined ? undefined : key;
    }

    if (isObject(key)) {
      if (!key[keyProperty]) {
        throw 'key should has property ' + keyProperty;
      }

      return key[keyProperty];
    }
  };
}

module.exports = {
  matching: KeyFactory('matchingKey'),
  bucketing: KeyFactory('bucketingKey', true)
};


//////////////////
// WEBPACK FOOTER
// ./~/@splitsoftware/splitio/lib/utils/key/factory.js
// module id = 262
// module chunks = 10